export const iconFontAwesomeMedicalHealthSquarePlus = (
	<i className="fa-solid fa-square-plus"></i>
);
